import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  mainDialog: {
    width: '100%',
    minWidth: '910px',
    padding: '1rem',
    direction: 'rtl',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
